export class Order{
    constructor(
        public _id: Number,
        public Tableno: String,
        public PhoneNumber : Number,
        public Createdby : String,
        public Total : Number,
        public Attribute1 : String
    ){}
}